module.exports = __webpack_public_path__ + "static/biometric-b19df492ccafbcc99e9ed5eb318cfed9.jpg";